import axiosInstance from 'api/axios';
import { servicesApiRes } from '../types/apiResponses';

export const servicesApiService = {
  getAllServices: async (): Promise<servicesApiRes> => {
    const response = await axiosInstance.public.get(`/api/v1/tele/services`);

    return response.data;
  },
};
